module.exports = __webpack_public_path__ + "img/bgpattern-top.bde3c87d.png";